export enum CONVERSION_TYPE {
	CONVERSATIONAL = 'conversational',
	FORM = 'form',
}
